import React from 'react';
import PropTypes from 'prop-types';
import Label from 'components/ui/form/label';
import Input from 'components/ui/form/input';
import { FormFieldError } from 'components/ui/index';
import classNames from 'classnames';

const FormRadioInput = (props) => {
  const { label, input, radioValue, meta, className, ...otherProps } = props;
  return (
    <div className={classNames('form-check', className)}>
      <Input
        type="radio"
        invalid={meta.touched && !!meta.error}
        {...input}
        id={`${input.name}_${radioValue}`}
        value={radioValue}
        checked={input.value === radioValue}
        {...otherProps}
      />
      <Label check htmlFor={`${input.name}_${radioValue}`}>
        {label}
      </Label>
      <FormFieldError meta={meta} />
    </div>
  );
};

FormRadioInput.defaultProps = {
  label: null,
  meta: {
    error: null,
    touched: false,
  },
};

FormRadioInput.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
};

export default FormRadioInput;
